import { Role } from '@/api/RoleApi';
import { BaseEntity } from '@/api/EntityApi';
import { UUID } from './types';

export enum UserStatus {
	INACTIVE = 'inactive',
	ACTIVE = 'active',
	SUSPENDED = 'suspended',
	WAITING_FOR_ACTIVATION = 'waiting_for_activation',
}
export enum UserType {
	CLIENT = 'client',
	ADMIN = 'admin',
}

interface BaseUser extends BaseEntity {
	firstName: string;
	lastName: string;
	email: string;
	password: string;
	status: UserStatus;
	userType: UserType;
}

export interface Admin extends BaseUser {
	role: Role;
	userType: UserType.ADMIN;
	name: string;
	lastName: string;
}

export type CustomerRepresentativeReference = {
	id: UUID;
	firstName: string;
	lastName: string;
};

export interface Client extends BaseEntity {
	phoneNumber: string;
	company: {
		companyName: string;
		vatNumber?: string;
	};
	street: string;
	city: string;
	country: string;
	houseNumber: string;
	postalCode: string;
	accountType: 'client' | 'dealer';
	canAddClients?: boolean;
	userType: UserType.CLIENT;
	firstName: string;
	lastName: string;
	status: UserStatus;
	email: string;
	customerRepresentative: CustomerRepresentativeReference | Admin;
}

export interface Dealer extends Client {
	margin: number;
	discount: number;
}

export interface ContactPerson extends BaseEntity {
	title: string;
	contactPerson: string;
	email: string;
	phone: string;
}

export type AppUser = Admin;
